import { render, staticRenderFns } from "./LandingFeatures.vue?vue&type=template&id=552d5c90&scoped=true"
import script from "./LandingFeatures.vue?vue&type=script&lang=js"
export * from "./LandingFeatures.vue?vue&type=script&lang=js"
import style0 from "./LandingFeatures.vue?vue&type=style&index=0&id=552d5c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552d5c90",
  null
  
)

export default component.exports